export const USER_HEADER = 'X-VSOLV-USER-ID';
export const ONE_TIME_TOKEN = 'vsolvToken';
